// extracted by mini-css-extract-plugin
module.exports = {"ourVision":"styles_ourVision__F4r7M","image":"styles_image__Ekrue","info":"styles_info__rPV9O","title":"styles_title__jy_2B"};